// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/start_credit_pack_purchase.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/billing/v1/start_credit_pack_purchase.proto.
 */
export const file_vision_billing_v1_start_credit_pack_purchase: GenFile = /*@__PURE__*/
  fileDesc("CjJ2aXNpb24vYmlsbGluZy92MS9zdGFydF9jcmVkaXRfcGFja19wdXJjaGFzZS5wcm90bxIYcHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxIo0BCh5TdGFydENyZWRpdFBhY2tQdXJjaGFzZVJlcXVlc3QSTwoGcGFyYW1zGAEgASgLMj8ucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLlN0YXJ0Q3JlZGl0UGFja1B1cmNoYXNlUmVxdWVzdC5QYXJhbXMaGgoGUGFyYW1zEhAKCHBhY2tfa2V5GAEgASgJIqcBCh9TdGFydENyZWRpdFBhY2tQdXJjaGFzZVJlc3BvbnNlElAKBnJlc3VsdBgBIAEoCzJALnByb3Rvcy52aXNpb24uYmlsbGluZy52MS5TdGFydENyZWRpdFBhY2tQdXJjaGFzZVJlc3BvbnNlLlJlc3VsdBoyCgZSZXN1bHQSFAoMY2hlY2tvdXRfdXJsGAEgASgJEhIKCnNlc3Npb25faWQYAiABKAliBnByb3RvMw");

/**
 * @generated from message protos.vision.billing.v1.StartCreditPackPurchaseRequest
 */
export type StartCreditPackPurchaseRequest = Message<"protos.vision.billing.v1.StartCreditPackPurchaseRequest"> & {
  /**
   * @generated from field: protos.vision.billing.v1.StartCreditPackPurchaseRequest.Params params = 1;
   */
  params?: StartCreditPackPurchaseRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.StartCreditPackPurchaseRequest.
 * Use `create(StartCreditPackPurchaseRequestSchema)` to create a new message.
 */
export const StartCreditPackPurchaseRequestSchema: GenMessage<StartCreditPackPurchaseRequest> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_start_credit_pack_purchase, 0);

/**
 * @generated from message protos.vision.billing.v1.StartCreditPackPurchaseRequest.Params
 */
export type StartCreditPackPurchaseRequest_Params = Message<"protos.vision.billing.v1.StartCreditPackPurchaseRequest.Params"> & {
  /**
   * @generated from field: string pack_key = 1;
   */
  packKey: string;
};

/**
 * Describes the message protos.vision.billing.v1.StartCreditPackPurchaseRequest.Params.
 * Use `create(StartCreditPackPurchaseRequest_ParamsSchema)` to create a new message.
 */
export const StartCreditPackPurchaseRequest_ParamsSchema: GenMessage<StartCreditPackPurchaseRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_start_credit_pack_purchase, 0, 0);

/**
 * @generated from message protos.vision.billing.v1.StartCreditPackPurchaseResponse
 */
export type StartCreditPackPurchaseResponse = Message<"protos.vision.billing.v1.StartCreditPackPurchaseResponse"> & {
  /**
   * @generated from field: protos.vision.billing.v1.StartCreditPackPurchaseResponse.Result result = 1;
   */
  result?: StartCreditPackPurchaseResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.StartCreditPackPurchaseResponse.
 * Use `create(StartCreditPackPurchaseResponseSchema)` to create a new message.
 */
export const StartCreditPackPurchaseResponseSchema: GenMessage<StartCreditPackPurchaseResponse> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_start_credit_pack_purchase, 1);

/**
 * @generated from message protos.vision.billing.v1.StartCreditPackPurchaseResponse.Result
 */
export type StartCreditPackPurchaseResponse_Result = Message<"protos.vision.billing.v1.StartCreditPackPurchaseResponse.Result"> & {
  /**
   * @generated from field: string checkout_url = 1;
   */
  checkoutUrl: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;
};

/**
 * Describes the message protos.vision.billing.v1.StartCreditPackPurchaseResponse.Result.
 * Use `create(StartCreditPackPurchaseResponse_ResultSchema)` to create a new message.
 */
export const StartCreditPackPurchaseResponse_ResultSchema: GenMessage<StartCreditPackPurchaseResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_start_credit_pack_purchase, 1, 0);

